export default __webpack_public_path__ + "static/media/Jen Dong.525d1af1.png";